<template>
	<div>
		<a-tag
			v-if="item"
			:color="item.Abierto ? $colors.primary : ''"
		>
			<a-tooltip placement="top">
				<template slot="title">
					<span v-if="item.Abierto">
						<fa-icon
							:icon="['fa', 'check-double']"
							class="mr-2"
						/>Abierto
					</span>
					<span v-else-if="item.Leido">
						<fa-icon
							:icon="['fa', 'check']"
							class="mr-2"
						/>Leido
					</span>
					<span v-else>
						<fa-icon
							:icon="['fa', 'envelope-open-text']"
							class="mr-2"
						/>Enviado
					</span>
				</template>

				<fa-icon
					v-if="item.Abierto"
					:icon="['fa', 'check-double']"
					class="mr-2 text-success"
				/>
				<fa-icon
					v-else-if="item.Leido"
					:icon="['fa', 'check']"
					class="mr-2 text-success"
				/>
				<fa-icon
					v-else
					:icon="['fa', 'envelope-open-text']"
					class="mr-2 text-primary"
				/>
			</a-tooltip>

			<a-tooltip placement="top">
				<template slot="title">
					{{ item.Fecha | moment("LLL") }}
				</template>
				{{ item.Fecha | moment("DD-MM-YYYY") }}
			</a-tooltip>
		</a-tag>

		<a-tag
			v-else
			size="small"
			:style="
				`color: ${$colors['gray-6']};
				border: 1px dashed ${$colors['gray-6']};
				background: transparent`
			"
		>
			<fa-icon
				:icon="['far', 'clock']"
				class="mr-2"
			/> No enviado
		</a-tag>
	</div>
</template>

<script>
export default {
	name: 'GTableSlotEmail',
	props: {
		item: {
			type: Object,
			required: false,
			default: null
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
